import { SelectMulti, SelectMultiProps } from '@/ui'
import { usePaymentMethods } from '@/api/usePaymentMethods'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGenerateCompanyPath } from '@/libs'
import AnimatedDots from '@/components/animated-dots/AnimatedDots'

interface SelectPMProps extends Omit<SelectMultiProps, 'items'> {}

export const SelectPaymentMethodMulti = (props: SelectPMProps) => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const { t } = useTranslation()
  const { data: items = [], isLoading } = usePaymentMethods(companyId, gameId)

  let options = useMemo(() => {
    return items
      .filter(it => it.settings.enabled && it.settings.global_enabled && it.dashboard_show && it.logo_url)
      .map(it => ({
        value: it.id as string,
        icon: () => <img src={it.logo_url} style={{ width: '32px', height: '32px' }} alt={it.caption} />,
        children: it.caption,
      }))
  }, [items])

  return (
    <SelectMulti
      {...props}
      items={options}
      placeholder={t('select-payment-methods')}
      renderMenuFooter={() => {
        if (isLoading) {
          return <AnimatedDots />
        }

        if (options.length == 0) {
          return (
            <div className="pb-3 text-center text-text-secondary">{t('select-payment-methods.no-enabled-methods')}</div>
          )
        }
      }}
    />
  )
}
